import { render, staticRenderFns } from "./DiagramWithTwoNarratives.vue?vue&type=template&id=2da1b7fd&scoped=true&"
import script from "./DiagramWithTwoNarratives.vue?vue&type=script&lang=js&"
export * from "./DiagramWithTwoNarratives.vue?vue&type=script&lang=js&"
import style0 from "./DiagramWithTwoNarratives.vue?vue&type=style&index=0&id=2da1b7fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da1b7fd",
  null
  
)

export default component.exports